// extracted by mini-css-extract-plugin
module.exports = {"cart-upsell":"cartUpsell-module__cart-upsell___zRo7O","cartUpsell":"cartUpsell-module__cart-upsell___zRo7O"};